var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgc"},[_vm._v(" "+_vm._s("暂无问卷")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }